export default __webpack_public_path__ + "static/media/medina-vertical-mobile.a638eeb4.png";